'use client';

import { motion } from 'framer-motion';

const traditionalItems = [
  { title: '6+ Months Development', description: 'Endless planning and over-engineering' },
  { title: '$50K–$100K+ Budget', description: 'Burning cash on unproven concepts' },
  { title: 'Zero User Feedback', description: 'Building in the dark without validation' },
  { title: 'Missed Market Window', description: "Competitors launch while you're still planning" },
];

const rapidItems = [
  { title: '28 Days to Launch', description: 'Fast execution with proven frameworks' },
  { title: '$15K–$25K Investment', description: 'Cost-effective validation before scaling' },
  { title: 'Real User Feedback', description: 'Validate with actual market demand' },
  { title: 'First-Mover Advantage', description: 'Beat competitors to market entry' },
];

const ProblemSection = () => {
  return (
    <section className="section-pad section-rule relative z-10 bg-background">
      <div className="mx-auto max-w-7xl">
        <motion.div
          className="mb-8 max-w-2xl sm:mb-12 lg:mb-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
        >
          <p className="mb-2 font-sans text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-primary sm:mb-3 sm:text-xs">
            Why founders switch
          </p>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-foreground sm:mb-4 sm:text-4xl lg:text-5xl">
            Traditional development vs rapid MVP
          </h2>
          <p className="text-sm leading-relaxed text-text-secondary sm:text-lg">
            Stop burning through your budget and missing market opportunities with slow development
            cycles.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-2 lg:gap-8">
          <motion.div
            className="rounded-xl border border-border bg-white/60 p-5 sm:p-8 lg:p-10"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <p className="mb-5 font-sans text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-text-secondary sm:mb-8 sm:text-xs">
              Traditional approach
            </p>
            <ul className="space-y-5 sm:space-y-7">
              {traditionalItems.map((item) => (
                <li key={item.title}>
                  <h3 className="mb-1 font-display text-base font-semibold text-foreground/70 sm:text-xl">
                    {item.title}
                  </h3>
                  <p className="text-sm text-text-secondary">{item.description}</p>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className="rounded-xl border border-primary/20 p-5 sm:p-8 lg:p-10"
            style={{
              background:
                'linear-gradient(160deg, rgba(120,8,216,0.08) 0%, rgba(252,160,0,0.06) 100%), #ffffff',
            }}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <p className="mb-5 font-sans text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-primary sm:mb-8 sm:text-xs">
              Rapid MVP approach
            </p>
            <ul className="space-y-5 sm:space-y-7">
              {rapidItems.map((item) => (
                <li key={item.title} className="flex gap-3">
                  <span
                    className="mt-2 h-2 w-2 shrink-0 rounded-full"
                    style={{ background: 'linear-gradient(135deg, #7808D8, #FCA000)' }}
                  />
                  <div>
                    <h3 className="mb-1 font-display text-base font-semibold text-foreground sm:text-xl">
                      {item.title}
                    </h3>
                    <p className="text-sm text-text-secondary">{item.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
